import React from 'react';
import { makeStyles } from '@mui/styles';
import { SupervisedUserCircleOutlined } from '@mui/icons-material';

export const HeaderModule = (props) => {

    const { icon, title, component, margin, background } = props;
    const classes = useStyles(margin);

    return (
        <div className={classes.container} style={{ background }}>
            {icon}
            <h3 className={classes.title}>{title}</h3>
            { component }
        </div>
    );
}

HeaderModule.defaultProps = {
    icon: <SupervisedUserCircleOutlined />,
    title: 'Title',
    component: <></>,
    margin: 0,
    background: '#fff',
    button: null
}

const useStyles = makeStyles(margin => ({
    container: {
        height: 80, 
        borderRadius: 6, 
        display: 'flex', 
        alignItems: 'center', 
        paddingLeft: 20,
        marginLeft: margin => margin,
        marginRight: margin => margin,
        marginTop: margin => margin,
        marginBottom: margin => margin
    },
    title: {
        fontFamily: 'Roboto', 
        marginLeft: 10, 
        marginRight: 20, 
        color: 'rgba(0,0,0, .6)'
    }
}));